"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var constant_manager_1 = __importDefault(require("constant-manager"));
exports["default"] = constant_manager_1["default"]({
    SOCKET_OPEN: '',
    SOCKET_WARNING_ENABLED: '',
    SOCKET_CONNECT_STATE: '',
    SOCKET_CLOSE: ''
}, { prefix: 'RC_CHAT_SOCKET__' });
